import { StoreCode } from '@portal/schema/storeCode';
import {
  SHOPIFY_AG1_POUCH_DOUBLE_SUB_VARIANT_ID,
  SHOPIFY_AG1_POUCH_DOUBLE_SUB_VARIANT_ID_V53,
  SHOPIFY_TRAVEL_PACK_OTP_VARIANT_ID_V53,
  SHOPIFY_AG1_POUCH_OTP_VARIANT_ID_V53,
  SHOPIFY_AG1_POUCH_SINGLE_SUB_VARIANT_ID,
  SHOPIFY_AG1_POUCH_SINGLE_SUB_VARIANT_ID_V53
} from '@portal/config/base';
import { getShopifyVariantId } from '@portal/shared/utils/subscriptionV2Helpers';

import { includesVariant } from './includesVariant';

export const isPouchSubscriptionVariant = (variantId: string, store: StoreCode) => {
  return (
    includesVariant(variantId, SHOPIFY_AG1_POUCH_SINGLE_SUB_VARIANT_ID[store]) ||
    includesVariant(variantId, SHOPIFY_AG1_POUCH_SINGLE_SUB_VARIANT_ID_V53[store]) ||
    includesVariant(variantId, SHOPIFY_AG1_POUCH_DOUBLE_SUB_VARIANT_ID[store]) ||
    includesVariant(variantId, SHOPIFY_AG1_POUCH_DOUBLE_SUB_VARIANT_ID_V53[store])
  );
};

export const isPouchOTPVariant = (variantId: string, store: StoreCode) => {
  const formattedVariantId = getShopifyVariantId(variantId);

  return includesVariant(formattedVariantId, SHOPIFY_AG1_POUCH_OTP_VARIANT_ID_V53[store]);
};

export const isTravelPackOTPVariant = (variantId: string, store: StoreCode) => {
  const formattedVariantId = getShopifyVariantId(variantId);

  return includesVariant(formattedVariantId, SHOPIFY_TRAVEL_PACK_OTP_VARIANT_ID_V53[store]);
};
